//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

import { ReactComponent as EyeOff } from 'assets/eye-off.svg';
import { ReactComponent as Eye } from 'assets/eye.svg';
import { useState } from 'react';
import { FieldError } from 'react-hook-form';
import ForwardRefInput, { ForwardRefInputProps } from './ForwardRefInput';

const PasswordWithEye = ({
  register,
  errorsName,
  size = 'max-w-xs',
  placeholder,
  disabled,
  cssType,
  autoFocus = false,
  autoComplete,
}: {
  register: ForwardRefInputProps;
  errorsName: FieldError | undefined;
  size?: string;
  placeholder?: string;
  disabled?: boolean;
  cssType?: React.CSSProperties;
  autoFocus?: boolean;
  autoComplete?: string;
}) => {
  const [passwordType, setPasswordType] = useState<'text' | 'password'>('password');
  const togglePassword = () => {
    passwordType === 'password' ? setPasswordType('text') : setPasswordType('password');
  };
  const borderColor = errorsName ? 'hsl(var(--er) / 0.3)' : 'hsl(var(--bc) / 0.3)';

  return (
    <div className={`flex ${size} ${disabled ? 'bg-gray-100' : 'bg-base-100'} border rounded dark:bg-gray-800`} style={{ ...cssType, borderColor }}>
      <ForwardRefInput
        className={`input input-eye flex-1` + (errorsName ? ' input-error' : '')}
        placeholder={placeholder}
        type={passwordType}
        {...register}
        disabled={disabled}
        style={cssType}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        data-testid={`input-for-name-${register.name}`}
      />
      <button type="button" className="mx-2" onClick={togglePassword} data-testid={`pwd-eye-btn-for-name-${register.name}`}>
        {passwordType === 'password' ? (
          <EyeOff className="w-4 h-4 text-cyfi-btn dark:hover:text-sonicfi-islandParadise hover:text-cyfi-hover" />
        ) : (
          <Eye className="w-4 h-4 text-cyfi-btn dark:hover:text-sonicfi-islandParadise hover:text-cyfi-hover" />
        )}
      </button>
    </div>
  );
};

export default PasswordWithEye;
